import React, { Component } from 'react'

import ContentInfo from '../_ContentInfo'
import Display from '../../../../../v2SPRINTA/atoms/Display'
import { FormGroup, Textarea } from '../../../../../v2SPRINTA/atoms/Form'
import { Col, Row } from '../../../../../v2SPRINTA/atoms/Grid'

import { saveExperience } from '../../_utils'


class Observation extends Component {
    inputRefs = {}

    handleChange(target) {
        let experience = this.props.data.experience
        experience[target.name] = target.value
        
        this.props.setData({
            experience
        }, () => {
            if(['radio', 'select-one', 'checkbox'].indexOf(target.type) > -1)
            this.handleChanged(target)
        })
    }
    
    handleChanged(target) {
        this.validAndSaveField(target)
    }

    validAndSaveField(target) {
        const { name } = target

        if(this.hasFieldError[name] && !this.hasFieldError[name]()) return;

        const form = {}
        form[name] = this.props.data.experience[name]

        let async = saveExperience(this.props.token, form)
        .then(resp => {})

        if(this.props.async) this.props.async(async)
    }

    hasFieldError = {
        
    }


    validate() {
        let errors = []

        Object.keys(this.hasFieldError).forEach(item => {
            let error = this.hasFieldError[item]();
            if(error)
            errors.push(error)
        })

        return errors
    }

    inStep() {
        let { note } = this.props.data.experience
        return note ? true  : false
    }

    render() {
        return (
            <ContentInfo
                title='Alguma observação?'
                description='Existe algum detalhe que não perguntamos e você gostaria de nos informar?'
                steps={this.props.steps}
                >

                <Row>
                    <Col size='12'>
                        <FormGroup>
                            <Display size={3}>
                                Observações
                            </Display>
                        </FormGroup>
                    </Col>

                    <Col size='12'>
                        <FormGroup>
                            <Textarea
                                label='Existe algum detalhe que não perguntamos?'
                                maxLength={600}
                                name="note"
                                value={this.props.data.experience.note || ''}
                                maxLengthString="Você digitou {lenght} de {limit} caracteres"
                                onChangeDOM={e => this.handleChanged(e.target)}
                                onChange={e => this.handleChange(e.target)}
                                />
                        </FormGroup>
                    </Col>
                </Row>

            </ContentInfo>
        )
    }

}

export default Observation


// WEBPACK FOOTER //
// ./src/App/pages/CreateExperience/Steps/Observation/index.js